import _ from "lodash"
import Mark from "mark.js"
const BASE_COLORS = ["#E3E2E0", "#ECE0DB", "#F5DFCC", "#FAEDCC", "#DEECDC", "#D6E4EE", "#E6DEED", "#F1E1E9", "#FAE3DE", "#F1F0F0"]
const LIGHT_COLORS = ["#f1f1ef", "#f4eeee", "#fbecdd", "#fbf3db", "#edf3ec", "#e7f3f8", "#f4f0f7", "#f9eef3", "#fdebec", "#F1F0F0"]
const DARK_COLORS = ["#111A2B", "#9f6b53", "#d9730d", "#cb912f", "#448361", "#337ea9", "#9065b0", "#c14c8a", "#d44c47", "#787774"]

const DEFAULT_PALETTE = {
  cast: {
    selected: {
      backgroundColor: BASE_COLORS,
      borderColor: DARK_COLORS,
    },
    unselected: {
      backgroundColor: BASE_COLORS,
      borderColor: BASE_COLORS,
    },
  },
  transcript: {
    selected: {
      backgroundColor: BASE_COLORS,
    },
    unselected: {
      backgroundColor: ["transparent"],
    },
  },
}

export default class HighlightTranscript {
  constructor({
    casts: casts,
    selected: initialSelected,
    markText: markText,
    palette: palette = {},
  }) {
    this.palette = _.merge({}, DEFAULT_PALETTE, palette)
    this.casts = casts.sort()
    this.selected = initialSelected || []
    this.markText = markText
    this.markers = new WeakMap()
  }

  toggleCast(cast) {
    if (!cast || cast == "") return

    if (this.selected.includes(cast)) {
      this.selected = this.selected.filter((c) => c !== cast)
    } else {
      this.selected = [...this.selected, cast]
    }

    return this.selected
  }

  applyHighlight(container) {
    switch (container.getAttribute("name")) {
      case "cast-item":
        this.#colorCastItem(container)
        break
      case "transcript-item":
        this.#colorTranscriptItem(container)
        break
    }

    const castItems = container.querySelectorAll("[name='cast-item']")
    castItems.forEach((item) => this.#colorCastItem(item))

    const transcriptItems = container.querySelectorAll("[name='transcript-item']")
    transcriptItems.forEach((item) => {
      this.#colorTranscriptItem(item)
      this.#tryMarkText(item)
    })
  }

  updateCasts(casts, selected) {
    this.casts = casts
    this.selected = selected || []
  }

  updateMarkText(text) {
    this.markers.forEach((marker) => {
      marker.unmark()
      if (text && text !== "") {
        marker.mark(text)
      }
    })
  }

  #colorCastItem(elem) {
    const cast = elem.dataset.castName
    const index = this.casts.indexOf(cast)
    const isSelected = this.selected.includes(cast)
    const styles = isSelected ? this.palette.cast.selected : this.palette.cast.unselected

    elem.classList.toggle("highlight", isSelected)
    elem.style.backgroundColor = this.#getColor(styles.backgroundColor, index)
    elem.style.borderColor = this.#getColor(styles.borderColor, index)
    elem.style.fontWeight = isSelected ? "600" : ""
  }

  #colorTranscriptItem(elem) {
    const casts = JSON.parse(elem.dataset.casts)
    const cast = casts.find((c) => this.selected.includes(c))
    const isSelected = Boolean(cast)
    const styles = isSelected ? this.palette.transcript.selected : this.palette.transcript.unselected
    const index = cast ? this.casts.indexOf(cast) : 0

    elem.classList.toggle("highlight", isSelected)
    elem.style.backgroundColor = this.#getColor(styles.backgroundColor, index)
  }

  #tryMarkText(elem) {
    if (!this.markText || this.markText === "") return

    if (this.markers.has(elem)) {
      // Already marked
      return
    }

    const marker = new Mark(elem)
    marker.mark(this.markText, {
      className: "bg-transparent font-bold",
      separateWordSearch: false,
    })
    this.markers.set(elem, marker)
  }

  #getColor(palette, index) {
    return palette[index % palette.length] || ""
  }
}
